import React from "react";

function HeaderInner({ title = "Page Title", description = "Default description goes here." }) {
  return (
    <section className="header-inner">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7">
            <div className="container-text">
              <h2>{title}</h2>
              <p>{description}</p>
              <a href="tel:+9876543210">+9876543210</a>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="car-sell-form">
              <h3>Sell your damaged car. We'll buy any car, any time!</h3>
              <form>
                <div className="row">
                  <div className="col-lg-6"><input type="text" name="name" placeholder="Name" required /></div>
                  <div className="col-lg-6"><input type="text" name="mobile" placeholder="Mobile Number" required /></div>
                  <div className="col-lg-6"><input type="email" name="email" placeholder="Email Address" required /></div>
                  <div className="col-lg-6"><input type="text" name="make_model" placeholder="Make & Model" required /></div>
                  <div className="col-lg-6"><input type="text" name="rego_number" placeholder="Rego Number/Plate Number" required /></div>
                  <div className="col-lg-6"><input type="text" name="pickup_location" placeholder="Pickup Location/Address" required /></div>
                  <div className="col-lg-12"><textarea name="vehicle_details" placeholder="Tell Us About Your Vehicle" rows="3"></textarea></div>
                  <button type="submit">Get An Offer</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeaderInner;
